<script setup>
import { usePage } from '@inertiajs/vue3';

const page = usePage();
const branding = page.props.branding;
</script>
<template>
  <img :src="branding.logo.src" :width="branding.logo.width" />
</template>
